import { useI18n } from 'vue-i18n'

/**
 * Enhanced translation composable that provides Vue 2 style tc function
 * for pluralization compatibility with Vue 3 and Vue I18n v10+
 */
export function useTranslation() {
  const { t, locale, ...rest } = useI18n()

  /**
   * Translate with pluralization (tc function for Vue 2 compatibility)
   * @param {string} key - The translation key
   * @param {number} count - The count for pluralization
   * @param {object} values - Additional values for interpolation
   * @returns {string} The translated and pluralized message
   */
  const tc = (key, count, values) => {
    return t(key, values ? { ...values, count } : { count }, count)
  }

  return {
    t,
    tc,
    locale,
    ...rest
  }
}
